import { client as sanityClient } from "@/services/sanity";
import { shallowRef } from "vue";

export interface RequestState<T> {
  status: "idle" | "loading" | "error" | "ready";
  data?: T;
  error?: Error;
}

// eslint-disable-next-line @typescript-eslint/no-explicit-any
type QueryParams = { [key: string]: any };

export default function useAPIRequest<
  T,
  QP extends QueryParams = QueryParams
>() {
  const requestState = shallowRef<RequestState<T>>({
    status: "idle",
  });

  const fetch = async (query: string, params?: QP) => {
    try {
      requestState.value = {
        status: "loading",
      };
      const data: T = await sanityClient.fetch(query, params || {});
      requestState.value = {
        status: "ready",
        data: data,
      };
      // eslint-disable-next-line @typescript-eslint/no-explicit-any
    } catch (error: any) {
      requestState.value = {
        status: "error",
        error: error as Error,
      };
    }
  };

  return { requestState, fetch };
}
